@if (form) {
  <form [formGroup]="form" (ngSubmit)="onOkClicked()">
    <div class="pb-7 p-4 pt-0">
      @if (question) {
        <div class="pb-3">
          {{question}}
        </div>
      }
      <div class="formgrid grid">
        <div class="field col-12">
          <label>{{label}}</label>

          @if (!dropdownItems && !onlyNumbers) {
            <input pInputText autofocus id="name" type="text" class="p-inputtext p-inputtext-sm w-full"
                   formControlName="name">
          }

          @if (!dropdownItems && onlyNumbers) {
            <p-inputNumber mode="decimal" [useGrouping]="false"
                           formControlName="name" class="grid-comp-full-width"/>
          }
          @if (dropdownItems) {
            <p-select appendTo="body"
                      [options]="dropdownItems"
                      formControlName="dropdownItem"
                      [placeholder]="'PLEASE_SELECT' | translate"
                      optionLabel="name"
                      optionValue="id"
                      class="grid-comp-full-width"/>
          }
        </div>
      </div>

      <app-message [active]="!!errorMsg" [message]="errorMsg"/>
    </div>

    <div class="dialog-footer flex">
      <div class="flex justify-content-end">
        <p-button type="submit" [label]="(saveLabel ? saveLabel : 'CREATE') | translate"
                  styleClass="p-button-text" icon="pi pi-check"
                  [loading]="isSaving"
                  [disabled]="isSaving ||  !(allowEmpty || form.controls.name.value || form.controls.dropdownItem.value)"/>
        <p-button (click)="onCancelClicked()" [label]="'CANCEL' | translate" styleClass="p-button-text"
                  icon="pi pi-times" [disabled]="isSaving"/>
      </div>
    </div>
  </form>
}
